import {Show, Text} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetDirectSaleVariantQuery} from '@dms/api/warehouse';

interface Props {
  variantId: string;
  branchId: string;
  isAuthorization: boolean;
  options: {value: string; label: string}[];
}

export function CheckoutRuleImpliedDirectParent(props: Props) {
  const {currentData: variant} = useGetDirectSaleVariantQuery({
    directSaleVariantId: props.variantId,
    branchId: props.branchId,
  });

  const parentId = props.isAuthorization
    ? variant?.general.authorizationProfileId
    : variant?.general.directSaleTypeId;

  const label = props.options.find((option) => option.value === parentId)?.label ?? parentId;

  return (
    <Show when={isNotNilOrEmpty(label) ? label : null}>
      {(text) => (
        <Text size="small" color="secondary">
          {text}
        </Text>
      )}
    </Show>
  );
}
